import type { Role, User } from "@packsize/identity-api-sdk";

export const getUserRoles = (user: User, roles: Role[]): Role[] => {
	return roles
		.filter((role) => user.assignedRoles?.includes(role.id) === true)
		.sort((firstRole, secondRole) => firstRole.name.localeCompare(secondRole.name));
};
